
import {Component, Prop} from 'vue-property-decorator';
import PazToast from '@pazion/pazion-core/src/components/utils/PazToast.vue';
import PazMenuDatepicker from '@pazion/pazion-core/src/components/input/PazMenuDatepicker.vue';
import Vue from 'vue';
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import {updateDossierProperty} from "@pazion/pazion-core/src/services/dossier-service";

@Component({
  components: {
    PazToast,
    PazMenuDatepicker,
    PazTooltipButton
  }
})
export default class DossierProperty extends Vue {
  $refs!: {
    toast: PazToast
  };
  public saving: boolean = false;
  public actualValue: any='';

  public propertyValue: string = '';
  @Prop()
  public canEdit!: boolean;
  @Prop()
  public field!: object;
  @Prop({default: ''})
  public dossierId!: string | number;

  @Prop({default: 'dossier'})
  public keyValue!: string;

  mounted() {
    if(this.field.values.hasOwnProperty(this.keyValue)) {
      this.propertyValue = this.field.values[this.keyValue].value;
      this.actualValue = this.field.values[this.keyValue].value;
    }
  }

  updatePropValue(arg) {
    this.propertyValue = arg;
  }

  get hasChanges() :boolean{
    return this.propertyValue != this.actualValue ?? false;
  }
  async saveProperty(field: object, data: any) {
    this.saving = true;
    const rsp = await updateDossierProperty(this.dossierId, field?.field?.name, data, this.keyValue=="dossier");
    if(rsp.success){
      this.$refs.toast.show({message: ( field?.field?.userFriendlyName ?? 'onbekend') + ' aangepast!'});
      this.actualValue = data;
    }
    this.saving = false;
  }
  displayFieldValue(value: string, dataType: string) {
    switch (dataType) {
      case 'Bit':
        if (value === 'True') {
          return 'Ja';
        }
        return 'Nee';
      case 'Datetime':
        const dt = Date.parse(value);
        if (isNaN(dt)) {
          return value;
        }
        return new Date(dt).toDateString();
    }
    return value;
  }
}
